/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const SSPAREPRESENTATIVE_ADD = 'SSPAREPRESENTATIVE_ADD';
export const SSPAREPRESENTATIVE_BEGIN = 'SSPAREPRESENTATIVE_BEGIN';
export const SSPAREPRESENTATIVE_FAILURE = 'SSPAREPRESENTATIVE_FAILURE';
export const SSPAREPRESENTATIVE_CLEAR = 'SSPAREPRESENTATIVE_CLEAR';

export const SSPAREPRESENTATIVE_FILTER_BEGIN = 'SSPAREPRESENTATIVE_FILTER_BEGIN';
export const SSPAREPRESENTATIVE_FILTER_SUCCESS = 'SSPAREPRESENTATIVE_FILTER_SUCCESS';
export const SSPAREPRESENTATIVE_FILTER_FAILURE = 'SSPAREPRESENTATIVE_FILTER_FAILURE';
export const SSPAREPRESENTATIVE_FILTER_CLEAR = 'SSPAREPRESENTATIVE_FILTER_CLEAR';

export function fetchSSPARepresentative(params = {}) {
	return async dispatch => {
        dispatch(sspaRepresentativeBegin());
        await ApiService.getResponsible(params)
			.then(
            result => {
                dispatch(sspaRepresentativeAdd(result));
				},
				error => {
                    dispatch(sspaRepresentativeError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchSSPARepresentativeFilter(params = {}) {
    return async dispatch => {
        await ApiService.getResponsibleFilter(params)
            .then(
                result => {
                    dispatch(sspaRepresentativeFilterAdd(result));
                },
                error => {
                    dispatch(sspaRepresentativeFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//SSPARepresentative
export const sspaRepresentativeBegin = () => ({
    type: SSPAREPRESENTATIVE_BEGIN,
});

export const sspaRepresentativeAdd = data => ({
    type: SSPAREPRESENTATIVE_ADD,
	payload: { data }
})

export const sspaRepresentativeError = () => ({
    type: SSPAREPRESENTATIVE_FAILURE,
})

export const sspaRepresentativeClear = () =>({
    type: SSPAREPRESENTATIVE_CLEAR,
})

//SSPARepresentative Filters
export const sspaRepresentativeFilterBegin = () => ({
    type: SSPAREPRESENTATIVE_FILTER_BEGIN,
});
export const sspaRepresentativeFilterAdd = filterData => ({
    type: SSPAREPRESENTATIVE_FILTER_SUCCESS,
    payload: { filterData }
})
export const sspaRepresentativeFilterError = filterError => ({
    type: SSPAREPRESENTATIVE_FILTER_FAILURE,
    payload: { filterError }
})

export const sspaRepresentativeFilterClear = () => ({
    type: SSPAREPRESENTATIVE_FILTER_CLEAR,
})
